/* eslint-disable no-throw-literal */
import { FORGOT_PASSWORD_ENDPOINT_SUFFIX, MODALITY_DEVICES_ENDPOINT, MODALITY_DEVICE_ENDPOINT, RESEND_VERIFICATION_EMAIL_ENDPOINT, RESET_PASSWORD_ENDPOINT, SCHEDULE_DEVICE_ENDPOINT, SERVICE_DEVICE_ENDPOINT, USER_PROFILE_ENDPOINT, modality_devices } from "../config/api-endpoints";
import { AUTH_CONFIG } from "../config/auth0";
import { SLACK_APP_TYPE, SLACK_WEB_HOOK } from "../config/constants";
import { authorizeHeader, facilityAuthorizeHeader } from "../utils/auth-header";
import AuthService from "../services/AuthService";
import { forEach } from "lodash";



const prepareNotificationPayload = (title, description, jsonContent) => {
  const auth = new AuthService()
  const { userBasicInfo: { email } } = auth.getProfile()
  let notificationMessage = '>>> [Connect: ' + email + '] - ' + title
  notificationMessage += '\n'
  if (description) {
    notificationMessage += '\n'
    notificationMessage += description
  }
  if (jsonContent) {
    forEach(jsonContent, (value, key) => {
      notificationMessage += '\n'
      notificationMessage += key + ': ' + value
    })
  }
  return {
    text: notificationMessage,
    username: 'Connect App [ ' + SLACK_APP_TYPE + ' ]'
  }
}



export const getModalityAPICall = async ({affiliatedGroup}) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const targetUrl = modality_devices + 'device/ad1f2570-d009-42ca-8cc8-8f977dcc1211/modality'
    const response = await window.fetch(targetUrl, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const getModalitySearchAPICall = async ({facility_id}) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }
    const targetUrl= modality_devices + `devices/facility/${facility_id}/modality`
    const response = await window.fetch(targetUrl, facilityAuthorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const putModalitySearchAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const config2 = authorizeHeader(config);
    config2.headers['Ocp-Apim-Subscription-Key'] = '50bed87351684bc88eb8fcfd4fdadeda';
    
    const targetUrl= modality_devices + `device/${requestBody?.guid}`
    const response = await window.fetch(targetUrl, config2)
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}



export const postModalitySearchAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const targetUrl= MODALITY_DEVICE_ENDPOINT
    const response = await window.fetch(targetUrl, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const getServicesSearchAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const targetUrl= SERVICE_DEVICE_ENDPOINT + "/search"
    const response = await window.fetch(targetUrl, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const postServicesAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const targetUrl= SERVICE_DEVICE_ENDPOINT
    const response = await window.fetch(targetUrl, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const putServicesAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const targetUrl= SERVICE_DEVICE_ENDPOINT + `/${requestBody.id}`
    const response = await window.fetch(targetUrl, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const deleteServicesAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const targetUrl= SERVICE_DEVICE_ENDPOINT + `/${requestBody.id}`
    const response = await window.fetch(targetUrl, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getScheduleDeviceAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }
    const targetURL = SCHEDULE_DEVICE_ENDPOINT
    const response = await window.fetch(targetURL, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getProfileAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      // body: JSON.stringify({autho_id: requestBody})
    }
    const targetURL = 'https://alemhealthapi.azure-api.net/teleradsetting/api/users/user-metadata'
    const response = await window.fetch(targetURL, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const postProfileAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const targetURL = USER_PROFILE_ENDPOINT
    const response = await window.fetch(targetURL, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
} 

export const putProfileAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({...requestBody, work_list_columns_setting: requestBody?.work_list_columns_setting || [], study_list_columns_setting: requestBody?.study_list_columns_setting || []})
    }
    const targetURL = `https://alemhealthapi.azure-api.net/teleradsetting/api/users/user-metadata`
    const response = await window.fetch(targetURL, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const postResetPasswordApiCall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const response = await window.fetch(RESET_PASSWORD_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    const responseOk =  responseStatus === 200

    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseOk, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const postForgotPasswordApiCall = async (targetEmail) => {
  try {
    const { clientID, connection, domain } = AUTH_CONFIG
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ client_id: clientID, connection, email: targetEmail })
    }
    const targetUrl = 'https://' + domain + FORGOT_PASSWORD_ENDPOINT_SUFFIX
    const response = await window.fetch(targetUrl, config)
    const data = await response.status === 200
    return data
  } catch (e) {
    console.error('ERROR: ', e)
    return e
  }
}


export const resendEmailApiCall = async (payload) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({user_id:payload, client_id:payload})
    }
    const response = await window.fetch(RESEND_VERIFICATION_EMAIL_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const postNotificationToSlackAPICall = async ({ title, jsonContent = null, description = null }) => {
  try {
    // if (!isProduction) {
    //   return false
    // }
    const payload = prepareNotificationPayload(title, description, jsonContent)
    const config = {
      method: 'POST',
      // headers: stripeAuthHeader,
      body: JSON.stringify(payload)
    }

    const response = await window.fetch(SLACK_WEB_HOOK, config)
    const data = await response.ok
    return data
  } catch (e) {
    console.log(e)
    return e
  }
}